(function () {
  // Pre Après — transparent nav bar over the homepage hero.
  // Homepage-only: exits immediately on every other template.
  //
  // This file no longer positions the header. The bar is `position: sticky`
  // in hero-header-overlay.css, so the browser keeps it pinned natively and
  // it can never lag behind the scroll. All this script does is:
  //   1. publish the header's height so the CSS can pull the hero up under it
  //   2. toggle one class when the hero has scrolled past the bar
  // Neither runs per scroll pixel, so there is nothing left to judder.
  if (!document.body.classList.contains('template-index')) return;

  var body = document.body;
  var root = document.documentElement;
  var headerSection = document.querySelector('.shopify-section-header');
  var hero = document.querySelector('#MainContent > *');
  if (!headerSection) return;

  var headerHeight = 0;

  function measureHeader() {
    headerHeight = headerSection.getBoundingClientRect().height;
    root.style.setProperty('--ppa-header-height', headerHeight + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader);
  if (window.ResizeObserver) {
    new ResizeObserver(measureHeader).observe(headerSection);
  }

  // Switches when the hero image has scrolled past the header, not at a
  // fixed scroll offset — stays white exactly as long as the hero image is
  // behind the bar, regardless of hero height. The hysteresis band keeps the
  // class from chattering when the crossing point is held still.
  var HYSTERESIS = 8;
  var scrolled = false;
  var ticking = false;

  function update() {
    ticking = false;
    var heroBottom = hero ? hero.getBoundingClientRect().bottom : -Infinity;

    if (!scrolled && heroBottom <= headerHeight - HYSTERESIS) {
      scrolled = true;
      body.classList.add('header-scrolled');
    } else if (scrolled && heroBottom >= headerHeight + HYSTERESIS) {
      scrolled = false;
      body.classList.remove('header-scrolled');
    }
  }
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
